<template>
  <div class="outer">
    <base-model :show="!!error" title="An error occurred" @close="handleError">
      <p>{{ error }}</p>
    </base-model>
    <base-model :show="isLoading" title="Loading..." fixed>
      <base-spinner></base-spinner>
    </base-model>
    <header><h3>Add New Employee</h3></header>
    <EmployeeForm :empInfo="employeeInfo" />
  </div>
</template>

<script>
import EmployeeForm from "../components/NewEmployee/EmployeeForm.vue";
export default {
  props: ["id"],
  data() {
    return {
      error: null,
      isLoading: false,
      employeeInfo:null
    };
  },
  created(){
    if(this.id){
      this.empData();
    }
  },
  methods: {
    empData() {
      this.isLoading = true;
      this.employeeInfo = this.$store.getters["employees/getEmployees"].find(
        (employee) => employee.id === this.id
      );
      this.isLoading = false;
    },
    handleError() {
      this.error = null;
    },
  },
  components: {
    EmployeeForm,
  },
};
</script>

<style scoped>
.outer {
  width: 98%;
  border: 1px solid #c1c1c1;
  margin: 1%;
}
header {
  padding: 0px 10px;
  background: slateblue;
  color: #fff;
  float: left;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 25px;
}
</style>
